import { groq } from 'next-sanity';
import { z } from 'zod';

import { link, SanityLink } from './link';
import { SanityTestimonial, testimonial } from './testimonial';

export const SanityTestimonialSection = SanityTestimonial.extend({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('testimonialSection'),
  _key: z.string(),
  theme: z.enum(['light', 'purple', 'charcoal']),
  eyebrow: z.string().optional().nullable(),
  cta: SanityLink.optional().nullable(),
});
export type SanityTestimonialSection = z.infer<typeof SanityTestimonialSection>;

export const testimonialSection = groq`{
  'theme': coalesce(theme, 'light'),
  eyebrow,
  ...(testimonial-> ${testimonial}),
  cta[0] ${link},
}`;
